(function ( $ ) {
    (function () {
        $('.add-to-cart').click(function (e) {
            let product_id = $(this).data("productId");
            let token = $('meta[name="csrf-token"]').attr('content');
            let quantity = 1;
            if ($(this).closest('.product-button').length) {
                quantity = parseInt($(this).closest('.product-button').find('.product-number').html());
            }

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find(".icon-font-cart").hide();
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/ajax/cart`, {
                    product_id: product_id,
                    quantity: quantity,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $('html').addClass('open-frame');
                    $('.popup-frame').css("display", "flex").hide().fadeIn();
                    $('.popup-added-to-cart').fadeIn();
                    $(".header-cart span").html(response.data.total_quantity);

                })
                .catch(error => {

                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find(".icon-font-cart").css('display','inline-block');
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });

        $('#cart .delete-from-cart').click(function (e) {
            let product_id = $(this).data("productId");
            let token = $('meta[name="csrf-token"]').attr('content');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find(".icon-font-close").hide();
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .delete(`/ajax/cart/${product_id}`, {
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $(".header-cart span").html(response.data.total_quantity);
                    if (Object.keys(response.data.order.order_items).length) {
                        $("#cart [data-product-id=\""+ product_id +"\"]").closest('tr').remove();
                        $("#cart [data-product-id=\""+ product_id +"\"]").closest('.cart-mob__item').remove();
                        $(".cart-info .total-price").html(response.data.order.total_price);
                    } else {
                        let pathArray = window.location.pathname.split('/');
                        var lang = pathArray[1];

                        if (lang === "ua") {
                            $('.cart.cart-page').html(`Корзина порожня`);
                        } else {
                            $('.cart.cart-page').html(`Корзина пуста`);
                        }
                    }
                })
                .catch(error => {

                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find(".icon-font-close").css('display','inline-block');
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });

        $('#cart .edit-cart-quantity').click(function (e) {
            let product_id = $(this).data("productId");
            let quantity = parseInt($(this).closest('.product-counter').find('.product-number').html());
            let token = $('meta[name="csrf-token"]').attr('content');

            $(this).closest('.cart-table__counter').find(".spinner-for-btn-wrapper").css('display','flex');

            axios
                .put(`/ajax/cart/${product_id}`, {
                    quantity: quantity
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $(".header-cart span").html(response.data.total_quantity);
                    $("#cart [data-product-id=\""+ product_id +"\"]").closest('.product-counter').find('.product-number').html(quantity);
                    $("#cart [data-product-id=\""+ product_id +"\"]").closest('.cart-mob__item').find('.total-price span').html(response.data.row.total_price);
                    $("#cart [data-product-id=\""+ product_id +"\"]").closest('tr').find('.total-price span').html(response.data.row.total_price);
                    $(".cart-info .total-price").html(response.data.order.total_price);
                })
                .catch(error => {

                })
                .then(() => {
                    $(this).closest('.cart-table__counter').find(".spinner-for-btn-wrapper").css('display','none');
                });
        });

        $('.order-radio').click(function(e) {
            let name = $(this).find('input').attr("name");
            let id = $(this).attr("for");
            $('.order-radio [name="'+name+'"]').closest('.order-radio').removeClass('order-radio_active');
            $('.order-radio [name="'+name+'"]').attr('checked', false);
            $("#"+id).attr("checked","checked");
            $(this).addClass('order-radio_active');
        });

        $('.order-check').click(function(e) {
            $(this).toggleClass('order-radio_active');
            let id = $(this).attr("for");
            if ( $(this).hasClass('order-radio_active')) {
                $("#" + id).attr("checked", "checked");
            } else {
                $("#" + id).attr("checked", false);
            }
            e.preventDefault();
        });

        $('.custom-check').click(function(e) {
            $(this).toggleClass('order-radio_active');
            let id = $(this).attr("for");
            if ( $(this).hasClass('order-radio_active')) {
                $("#" + id).attr("checked", "checked");
            } else {
                $("#" + id).attr("checked", false);
            }
            e.preventDefault();
        });


        $("#checkout-form").submit(function (e) {
            e.preventDefault();
            let name = $(".cart-info [name=\"name\"]").val();
            let phoneNumber = $(".cart-info [name=\"phone\"]").val();
            let email = $(".cart-info [name=\"email\"]").val();
            let delivery_id = $(".cart-form [name=\"city\"]").closest('.order-group-radio-item').find("[name=\"delivery\"]").val();
            let pay = $(".cart-form [name=\"pay\"]:checked").val();
            let city = $(".cart-form [name=\"city\"]").val();
            let address = $(".cart-form [name=\"address\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');

            $("#checkout-form input[type='submit']").prop('disabled', true);
            $("#checkout-form .spinner-for-btn").css('display','inline-block');

            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];

            axios
                .post(`/ajax/checkout`, {
                    name: name,
                    phoneNumber: phoneNumber,
                    email: email,
                    delivery_id: delivery_id,
                    pay: pay,
                    city: city,
                    address: address,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    // $('html').addClass('open-frame');
                    // $('.popup-frame').css("display", "flex").hide().fadeIn();
                    // $('.popup-checkout-completed').fadeIn();
                    window.location.href= (lang === "ua") ? "/ua/checkout-complete" : "checkout-complete";
                })
                .catch(error => {

                })
                .then(() => {
                    $("#checkout-form .spinner-for-btn").hide();
                    $("#checkout-form input[type='submit']").prop('disabled', false);
                });
        })
    }());

}( jQuery ));


